import { render, staticRenderFns } from "./FormDetails.vue?vue&type=template&id=57a641cb&scoped=true&"
import script from "./FormDetails.vue?vue&type=script&lang=js&"
export * from "./FormDetails.vue?vue&type=script&lang=js&"
import style0 from "./FormDetails.vue?vue&type=style&index=0&id=57a641cb&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.10.2_cache-loader@4.1.0_webpack@4.47.0__css-loader@3.6.0_webpack@4.47.0__lodash_7gprpqnc7s6aitlohrfuswmoxa/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57a641cb",
  null
  
)

export default component.exports